/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recurringday1Inputs */

const en_recurringday1 = /** @type {(inputs: Recurringday1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`day`)
};

const de_recurringday1 = /** @type {(inputs: Recurringday1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag`)
};

/**
* | output |
* | --- |
* | "day" |
*
* @param {Recurringday1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const recurringday1 = /** @type {((inputs?: Recurringday1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recurringday1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recurringday1(inputs)
	return de_recurringday1(inputs)
});
export { recurringday1 as "recurringDay" }